<template>
  <div
    v-show="isVisible"
    class="relative w-full p-3 desktop:ml-[calc(-50vw+50%)] desktop:w-screen"
    :style="{ background: backgroundColor }"
    :data-ab-id="dataAbId"
  >
    <KikButton
      class="absolute right-1 top-1"
      variant="tertiary"
      :square="true"
      :aria-label="$t('Close')"
      @click="closeNotification"
    >
      <SfIconClose size="sm" />
    </KikButton>
    <div
      class="mobile:mr-7 desktop:mx-7 [&_p]:text-center mobile:[&_p]:text-left"
      v-html="contentRTE"
    />
  </div>
</template>

<script lang="ts" setup>
import { SfIconClose } from '@storefront-ui/vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const { $domain } = useNuxtApp();

interface Props {
  content?: string;
  visible?: boolean;
  id?: string;
  backgroundColor?: string;
  dataAbId?: string;
}

const props = withDefaults(defineProps<Props>(), {
  content: '',
  visible: false,
});

const open = ref(true);

const contentRTE = computed(() => magnoliaGetters.resolveRichTextContentAssetLinks(props?.content, $domain.cmsAssetDomainPath));
const closeNotification = () => open.value = false;
const isVisible = computed(() => props.visible && open.value);
</script>
